import React from "react";
import NavbarTwo from "../../components/App/NavbarTwo";
import Footer from "../../components/App/Footer";
import Layout from "../../components/App/Layout";

import StartProject from "../../components/Programs/ProgramsIndex/StartProject";
import AboutUs from "../../components/Programs/ProgramsIndex/AboutUs";
import UpcomingBootcamps from "../../components/Programs/ProgramsIndex/UpcomingBootcamps";
import Services from "../../components/Programs/ProgramsIndex/Services";
import Pricing from "../../components/Programs/ProgramLayout/Pricing";
import ProgramLevels from "../../components/Programs/ProgramsIndex/ProgramLevels";

const Home = () => {
  return (
    <Layout
      seoTitle="Learn to Code and Robotics Programs for Grade 2 - 8 students"
      seoDescription="Computational Thinking and Programming concepts introduction to students in elementary grades to middle school."
    >
      <NavbarTwo />
      <StartProject />

      <ProgramLevels />
      <Services />
      {/* <AboutUs /> */}
      <Pricing />
      <UpcomingBootcamps />

      <Footer />
    </Layout>
  );
};

export default Home;
